import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';

const objectType = 'larval-sites';

class LarvalSitesService extends BaseService {

  static getList(page) {

    return super.get(`larval_sites?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static search(search, page) {
    return this.siteSearch(search, page);
  }

  static siteSearch(search, page = 1) {

    return super.get(`larval_sites/site-search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static getDetails(id) {
    return super.get(`larval_sites/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities[objectType][object.result[objectType][0]];
        // data.comments = object.entities.comments;
        data.larvicides = object.entities.larvicides;
        data = camelizeKeys(data);
        data = dates.datepickerFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);
        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {

    data = dates.apiFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);

    return super.post(objectType, `larval_sites`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    data = dates.apiFormat(data, ['foundDate', 'contactDate', 'scheduleStart']);

    return super.patch(objectType, `larval_sites/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`larval_sites/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static shape(data) {
    return super.post(objectType, `larval_sites/shape`, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static createShapes(data) {
    return super.post(objectType, `larval_sites/shape-bulk`, data)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }


}

export default LarvalSitesService;